module.exports = __webpack_public_path__ + "static/elder_brain-6fdc1ec4785cbd4f50d8dc73878ded70.jpeg";